import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-rapports',
  imports: [],
  templateUrl: './rapports.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './rapports.css',
})
export class Rapports {}
